export default "__VITE_ASSET__43b5b8e1__"